module.exports = __webpack_public_path__ + "static/media/VPM_laptop_2.abbf1ba0.jpg";